import axios from "axios";

export const uploadFileToS3 = async (
  presignedUrl: string,
  file: File,
  onProgress?: (progress: number) => void
) => {
  const response = await axios.put(presignedUrl, file, {
    headers: {
      "Content-Type": file.type,
    },
    onUploadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        onProgress(progress);
      }
    },
  });
  return response;
};

export const uploadChunkToS3 = async (
  presignedUrl: string,
  chunk: Blob,
  contentType: string,
  onProgress?: (progress: number) => void,
  signal?: AbortSignal
): Promise<string | null> => {
  const response = await axios.put(presignedUrl, chunk, {
    headers: {
      "Content-Type": contentType,
    },
    signal,
    onUploadProgress: (progressEvent) => {
      if (
        onProgress &&
        progressEvent.progress != undefined &&
        progressEvent.total != undefined
      ) {
        onProgress(progressEvent.bytes / progressEvent.total);
      }
      // if (onProgress && progressEvent.total) {
      //   const progress = Math.round(
      //     (progressEvent.loaded * 100) / progressEvent.total
      //   );
      //   onProgress(progress);
      // }
    },
  });

  let etag = response.headers["etag"] ?? null;

  if (etag && typeof etag === "string") {
    etag = etag.replace(/^"(.+)"$/, "$1");
  }

  return etag;
};
